import {Router, Routes, Route, Outlet, Link } from 'react-router-dom'

import Uganda from './uganda';
import Uganda_s4_subjects from './uganda_s4_subjects';
import TopNavbar from '../../components/TopNavbar';
import International_countries from '../international_countries';

const Uganda_s4 = ( ) => {
 
  return (
    <>
  <TopNavbar />
   <Uganda />
   <International_countries />
  <Uganda_s4_subjects />  
  
     <Outlet />
   

</>
  );
}

export default Uganda_s4;
